export enum CHAT_SESSION_SOURCE {
  FACEBOOK = 'facebook',
  ZALO = 'zalo',
  MESSENGER = 'messenger',
  LIVE = 'livechat'
}
